import { menuAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(menuAnatomy.keys);

// define the base component styles
const baseStyle = definePartsStyle({
  list: {
    py: "4",
    borderRadius: "xl",
    bg: "white",
  },
  item: {
    fontSize: "1rem",
    py: "3",
    color: "background",
    _hover: {
      //   color: "white",
      bg: "transparent",
    },
    _focus: {
      bg: "transparent",
      //   color: "white",
    },
  },
});

export default defineMultiStyleConfig({ baseStyle });
